export const modelOptions = [
    {
        label: '水星300系列',
        value: 'SX300',
        children: [
            {
                label: '水星390M',
                value: 'SX390M',
                letter: 'A',
            }, 
            {
                label: '水星380M',
                value: 'SX380M',
                letter: 'A',
            }, 
            {
                label: '水星360M',
                value: 'SX360M',
                letter: 'A',
            }, 
            {
                label: '水星350M',
                value: 'SX350M',
                letter: 'A',
            }, 
            {
                label: '水星390S',
                value: 'SX390S',
                letter: 'A',
            }, 
            {
                label: '水星380S',
                value: 'SX380S',
                letter: 'A',
            }, 
            {
                label: '水星360S',
                value: 'SX360S',
                letter: 'A',
            }, 
            {
                label: '水星350S',
                value: 'SX350S',
                letter: 'A',
            }, 
            {
                label: '水星390E',
                value: 'SX390E',
                letter: 'A',
            }, 
            {
                label: '水星380E',
                value: 'SX380E',
                letter: 'A',
            }, 
            {
                label: '水星360E',
                value: 'SX360E',
                letter: 'A',
            }, 
            {
                label: '水星350E',
                value: 'SX350E',
                letter: 'A',
            }, 
            {
                label: '水星390C',
                value: 'SX390C',
                letter: 'A',
            }, 
            {
                label: '水星380C',
                value: 'SX380C',
                letter: 'A',
            }, 
            {
                label: '水星360C',
                value: 'SX360C',
                letter: 'A',
            }, 
            {
                label: '水星350C',
                value: 'SX350C',
                letter: 'A',
            }, 
        ]
    },
    {
        label: '天鹅6000系列',
        value: 'Swan6000',
        children: [
            {
                label: '天鹅6000',
                value: 'Swan6000',
                letter: 'A',
            },
            {
                label: '天鹅6100E',
                value: 'Swan6100E',
                letter: 'A',
            },
            {
                label: '天鹅6200E',
                value: 'Swan6200E',
                letter: 'A',
            },
            {
                label: '天鹅6100S',
                value: 'Swan6100S',
                letter: 'A',
            },
            {
                label: '天鹅6200S',
                value: 'Swan6200S',
                letter: 'A',
            },
            {
                label: '天鹅6500M',
                value: 'Swan6500M',
                letter: 'A',
            },
            {
                label: '天鹅6600M',
                value: 'Swan6600M',
                letter: 'A',
            },

        ]
    },
    {
        label: '天鹅6000P系列',
        value: 'Swan6000P',
        children: [

            {
                label: '天鹅6000P',
                value: 'Swan6000P',
                letter: 'B',
            },
            {
                label: '天鹅6300E',
                value: 'Swan6300E',
                letter: 'B',
            },
            {
                label: '天鹅6600E',
                value: 'Swan6600E',
                letter: 'B',
            },
            {
                label: '天鹅6300S',
                value: 'Swan6300S',
                letter: 'B',
            },
            {
                label: '天鹅6500S',
                value: 'Swan6500S',
                letter: 'B',
            },
            {
                label: '天鹅6600S',
                value: 'Swan6600S',
                letter: 'B',
            },
            {
                label: '天鹅6700M',
                value: 'Swan6700M',
                letter: 'B',
            },
            {
                label: '天鹅6800M',
                value: 'Swan6800M',
                letter: 'B',
            },
            {
                label: '天鹅6900M',
                value: 'Swan6900M',
                letter: 'B',
            },

        ]
    },
    {
        label: '天鹅7000系列',
        value: 'Swan7000',
        children: [
            {
                label: '天鹅7000',
                value: 'Swan7000',
                letter: 'A',
            },
            {
                label: '天鹅7100E',
                value: 'Swan7100E',
                letter: 'A',
            },
            {
                label: '天鹅7200E',
                value: 'Swan7200E',
                letter: 'A',
            },
            {
                label: '天鹅7100S',
                value: 'Swan7100S',
                letter: 'A',
            },
            {
                label: '天鹅7200S',
                value: 'Swan7200S',
                letter: 'A',
            },
            {
                label: '天鹅7500M',
                value: 'Swan7500M',
                letter: 'A',
            },
            {
                label: '天鹅7600M',
                value: 'Swan7600M',
                letter: 'A',
            },
        ]
    },
    {
        label: '天鹅7000P系列',
        value: 'Swan7000P',
        children: [
            {
                label: '天鹅7000P',
                value: 'Swan7000P',
                letter: 'B',
            },
            {
                label: '天鹅7300E',
                value: 'Swan7300E',
                letter: 'B',
            },
            {
                label: '天鹅7600E',
                value: 'Swan7600E',
                letter: 'B',
            },
            {
                label: '天鹅7300S',
                value: 'Swan7300S',
                letter: 'B',
            },
            {
                label: '天鹅7500S',
                value: 'Swan7500S',
                letter: 'B',
            },
            {
                label: '天鹅7600S',
                value: 'Swan7600S',
                letter: 'B',
            },
            {
                label: '天鹅7700M',
                value: 'Swan7700M',
                letter: 'B',
            },
            {
                label: '天鹅7800M',
                value: 'Swan7800M',
                letter: 'B',
            },
            {
                label: '天鹅7900M',
                value: 'Swan7900M',
                letter: 'B',
            },
        ]
    },
    {
        label: 'Draco8000系列',
        value: 'Draco8000',
        children: [
            // B系列
            {
                label: '天龙8900M',
                value: 'Draco8900M',
                letter: 'B',
            },
            {
                label: '天龙8800M',
                value: 'Draco8800M',
                letter: 'B',
            },
            {
                label: '天龙8700M',
                value: 'Draco8700M',
                letter: 'B',
            },
            {
                label: '天龙8600S',
                value: 'Draco8600S',
                letter: 'B',
            },
            {
                label: '天龙8500S',
                value: 'Draco8500S',
                letter: 'B',
            },
            {
                label: '天龙8300S',
                value: 'Draco8300S',
                letter: 'B',
            },
            {
                label: '天龙8600E',
                value: 'Draco8600E',
                letter: 'B',
            },
            {
                label: '天龙8300E',
                value: 'Draco8300E',
                letter: 'B',
            },
            // A系列
            {
                label: '天龙8600M',
                value: 'Draco8600M',
                letter: 'A',
            },
            {
                label: '天龙8500M',
                value: 'Draco8500M',
                letter: 'A',
            },
            {
                label: '天龙8200S',
                value: 'Draco8200S',
                letter: 'A',
            },
            {
                label: '天龙8100S',
                value: 'Draco8100S',
                letter: 'A',
            },
            {
                label: '天龙8200E',
                value: 'Draco8200E',
                letter: 'A',
            },
            {
                label: '天龙8100E',
                value: 'Draco8100E',
                letter: 'A',
            },
        ]
    },
    {
        label: 'Draco9000系列',
        value: 'Draco9000',
        children: [
            // B系列
            {
                label: '天龙9900M',
                value: 'Draco9900M',
                letter: 'B',
            },
            {
                label: '天龙9800M',
                value: 'Draco9800M',
                letter: 'B',
            },
            {
                label: '天龙9700M',
                value: 'Draco9700M',
                letter: 'B',
            },
            {
                label: '天龙9600S',
                value: 'Draco9600S',
                letter: 'B',
            },
            {
                label: '天龙9500S',
                value: 'Draco9500S',
                letter: 'B',
            },
            {
                label: '天龙9300S',
                value: 'Draco9300S',
                letter: 'B',
            },
            {
                label: '天龙9600E',
                value: 'Draco9600E',
                letter: 'B',
            },
            {
                label: '天龙9300E',
                value: 'Draco9300E',
                letter: 'B',
            },
            // A系列
            {
                label: '天龙9600M',
                value: 'Draco9600M',
                letter: 'A',
            },
            {
                label: '天龙9500M',
                value: 'Draco9500M',
                letter: 'A',
            },
            {
                label: '天龙9200S',
                value: 'Draco9200S',
                letter: 'A',
            },
            {
                label: '天龙9100S',
                value: 'Draco9100S',
                letter: 'A',
            },
            {
                label: '天龙9200E',
                value: 'Draco9200E',
                letter: 'A',
            },
            {
                label: '天龙9100E',
                value: 'Draco9100E',
                letter: 'A',
            },
        ]
    },
    {
        label: 'Columba3000系列',
        value: 'Columba3000',
        children: [{
            label: "天鸽3000",
            value: 'Columba3000',
            letter: "A",
        },
        {
            label: "天鸽3000S",
            value: 'Columba3000S',
            letter: "B",
        },]
    },
    {
        label: '筛查箱',
        value: 'SCX',
        children: [{
            label: "筛查箱3100",
            value: 'SCX3100',
            letter: "B",
        },
        {
            label: "筛查箱3100S",
            value: 'SCX31000S',
            letter: "A",
        },]
    },
    {
        label: '星豚',
        value: 'XT',
        children: [
            {
                label: "星豚220",
                value: 'XT220',
                letter: "A",
            },
            {
                label: "星豚230",
                value: 'XT230',
                letter: "A",
            },
            {
                label: "星豚260",
                value: 'XT260',
                letter: "A",
            },
            {
                label: "星豚270",
                value: 'XT270',
                letter: "A",
            },
        ]
    },
    {
        label: '蓝鲸',
        value: 'LJ',
        children: [
            {
                label: "LanW110",
                value: 'LanW110',
                letter: "A",
            },]
    }
];